export function noBreackingSpace(content = false) {
    let elements
    if (!content) {
        elements = $('p, span, a, h1, h2, h3, h4, h5, h6')
    } else {
        elements = $(content).find('p, span, a, h1, h2, h3, h4, h5, h6')
    }
    // console.log(elements)
    // let selector = $('p, span, a, h1, h2, h3, h4, h5, h6');
    // let elements = [];
    // selector.each(function () {
    //     // console.log($(this).children().length+' |'+$(this).html()+'|');
    //     if ($(this).children().length === 0 && $(this).text()) {
    //         elements.push($(this))
    //     }
    // })
    // console.log('-----------------------------------------------------------------------------------');
    // $.each(elements, function () {
    //     console.log('-'+$(this).html()+'-');
    // })
    // console.log(selector.length, elements.length)

    let regexNumber = /([0-9]+)( )(‰|%|€|:|[0-9]+)+/gm;
    elements.each(function () {
        let html = $(this).html()
        if (html.match(regexNumber)) {
            // console.log(html)
            $(this).html(html.replace(regexNumber, "$1&#160;$3"));
        }
    })
    let regexNumber2 = /([a-z]|[0-9]+)( )(:+)+/gm;
    elements.each(function () {
        let html = $(this).html()
        if (html.match(regexNumber2)) {
            // console.log(html)
            $(this).html(html.replace(regexNumber2, "$1&#160;$3"));
        }
    })

    // let regexQuote = /^(«|"+)( )(.+)(»|"+)$/gm
    // let regex3 = /^<.+>(«|")+( )(.)+<\/.+>$/;
    // let regex3 = /^<.+>(«|"+)( )(.+)+<\/.>$/;
    // $.each(elements, function () {
    //     let html = $(this).html()
    //     if (html.match(regexQuote)) {
    //         $(this).html(html.replace(regexQuote, "$1&#160;$3$4"));
    //     }
    // })

    // let regex2 = /(.+)( )(»|"+)+/;
    // $.each(elements, function () {
    //         $(this).html($(this).html().replace(regex2, "$1&#160;$3"))
    // })
    // let regex3 = /(«|"+)( )(.+)+/;
    // $.each(elements, function () {
    //     $(this).html($(this).html().replace(regex3, "$1&#160;$3"))
    // })

}
noBreackingSpace($('#main-content'))
